import { Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[libClickOutside]',
  standalone: true,
  host: {
    '(document:click)': 'onClick($event.target)',
  },
})
export class ClickOutsideDirective {
  readonly clickOutside = output<void>();
  readonly elementRef = inject(ElementRef);

  public onClick(targetElement: EventTarget): void {
    const isClickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
      this.clickOutside.emit();
    }
  }
}
